// extracted by mini-css-extract-plugin
export default {"farbfeld":"layout_farbfeld__tB+Ia","stripes":"layout_stripes__g25kh","yellow":"layout_yellow__uByJW","shadow":"layout_shadow__LJCC7","slots":"layout_slots__hLxrD"};